import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Teccss.css'
import teclogo from '../Assets/Images/tec.png'

function Kdptecnavbar({openSidebar}) {

  useEffect(()=>{

    document.getElementById("usernametec").innerHTML=localStorage.getItem('username')
    document.getElementById("role").innerHTML=localStorage.getItem('RoleName')

  });
    return (
        <div className='kdptec-navbar'>
  
        <div className='kdptec-nav-icon' >

          <i className='fa fa-bars' onClick={openSidebar}></i>
         </div>
         <div className='kdptec-navbar-left'>

<div className='kdptec-sidebar-img'>

  <img src={teclogo} alt="logo"/>&nbsp;&nbsp;


</div>

</div>

         <div className="kdptec-navbar-right">

         </div>


      <div className='kdptec-navbar-right'>
          
          <a href='#'>
          <i class="fa fa-user-circle" aria-hidden="true"></i>
          </a>
          <div className='kdptec-right-navbar'>
          <span id="usernametec"></span>
          (<span id="role"></span>)
          </div>
           

      </div>

 
        
      </div>
    );
}

export default Kdptecnavbar;